import { render, staticRenderFns } from "./NegoHistory.vue?vue&type=template&id=2afed108"
import script from "./NegoHistory.vue?vue&type=script&lang=js"
export * from "./NegoHistory.vue?vue&type=script&lang=js"
import style0 from "./NegoHistory.vue?vue&type=style&index=0&id=2afed108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports